import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import Header from './Header.js';

import { books, countBooks } from './Books.js'

class BookList extends Component {
    render() {
        return (
            <div id="page">
                <Header /> 
                <Container id="body">
                    <div id="resources" className="more-stuff-page">
                        <div id="BooklistHeader">
                            <h3 id="Booklist">Booklist</h3>
                            <p>The majority of my readings are on transpersonal psychology,
                                consciousness, spirituality, and metaphysics, as those areas
                                fascinate me most. The books are in no particular order, but I have
                                grouped them into different categories to make it easier to find
                                something interesting. Books with a <b><i>notes </i></b> link are one's
                                which I have added my own personal detailed booknotes.</p> <i>There are
                                    currently&nbsp;<mark>{countBooks()}</mark>&nbsp;books in this list.</i>
                        </div>
                        <hr />
                        {books.map((section, sectionIndex) =>
                            <div id="section" key={sectionIndex}>
                                <h6 id="sectionHeader">{section.section}</h6>
                                <ol>
                                    {section.books.map((book, bookIndex) =>
                                        <li id="bookSection" key={bookIndex}>
                                            {"img" in book &&
                                                <div id="bookImg">
                                                    <img src={book.img} alt="" width="100px"></img>
                                                </div>
                                            }
                                            <div id="bookInfo">
                                                <span id="bookTitle">{book.title}</span>{"img" in book && <br />}
                                                <span id="bookInfoAuthor">
                                                    {book.author}
                                                    {"date" in book && <span> - {book.date}</span>}
                                                    {"notes" in book && <span><br /><a href={book.notes} id="notes">Notes</a></span>}
                                                    {"link" in book && <span><br /><a href={book.link}>Store Link</a></span>}
                                                </span>
                                            </div>
                                            <div id="bookSectionFooter"></div>
                                        </li>
                                    )}
                                </ol>
                                <hr />
                            </div>
                        )}
                    </div>
                </Container>
            </div>
        );
    }
}

export default BookList;
